<template>
   <div class="tabulation">
      <el-card class="chart-card" v-loading="pageLoading">
         <div style="margin-top: 20px;">
            <el-form ref="ruleFormRef" :model="form" :rules="rules" class="demo-ruleForm" :size="formSize" status-icon>
                <el-form-item label="产品名称" prop="productName">
                  <div class="aaaa">
                     <el-input v-model="form.productName" placeholder="请输入产品名称" />
                  </div>
               </el-form-item>
               
               <el-form-item label="产品编码" prop="productCode">
                  <div class="aaaa">
                     <el-input v-model="form.productCode" placeholder="请输入产品编码" />
                  </div>
               </el-form-item>

               <el-form-item label="年度费用" prop="annualFee">
                  <div class="aaaa">
                     <el-input v-model.number="form.annualFee" type="number" placeholder="请输入年度费用" />
                  </div>
               </el-form-item>

               <el-form-item label="工会补助金额" prop="unionSubsidy">
                  <div class="aaaa">
                     <el-input v-model.number="form.unionSubsidy" type="number" placeholder="请输入工会补助金额" />
                  </div>
               </el-form-item>

               <el-form-item label="会员支付金额" prop="memberFee">
                  <div class="aaaa">
                     <el-input v-model.number="form.memberFee" type="number" placeholder="请输入会员支付金额" />
                  </div>
               </el-form-item>

               <el-form-item label="状态" prop="status">
                  <div class="aaaa">
                     <el-select v-model="form.status" placeholder="请选择状态" clearable>
                        <el-option label="停用" :value="0" style="width:100%; text-align-last: center;" />
                        <el-option label="启用" :value="1" style="width:100%; text-align-last: center;" />
                     </el-select>
                  </div>
               </el-form-item>

               <el-form-item label="排序" prop="sort">
                  <div class="aaaa">
                     <el-input v-model.number="form.sort" type="number" placeholder="请输入排序值（提示：大到小排序 默认1000）" />
                  </div>
               </el-form-item>

               <div class="submit">
                  <el-form-item>
                     <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
                  </el-form-item>
               </div>
            </el-form>
         </div>
      </el-card>
   </div>
</template>

<script setup>
import { nextTick, onActivated, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import qs from "qs";
import { queryProductInfo, updateProduct } from "../../utils/api";

const router = useRouter();
const route = useRoute();
const ruleFormRef = ref(null);
const formSize = ref("large");
const loading = ref(false);
const pageLoading = ref(false);
const productId = ref("");

const form = reactive({
   productCode: "",
   productName: "",
   annualFee: "",
   unionSubsidy: "",
   memberFee: "",
   status: "",
   sort: "",
});

const resetFormData = () => {
   form.productCode = "";
   form.productName = "";
   form.annualFee = "";
   form.unionSubsidy = "";
   form.memberFee = "";
   form.status = "";
   form.sort = "";
   nextTick(() => {
      ruleFormRef.value && ruleFormRef.value.clearValidate();
   });
};

const validateNonNegative = (message) => {
   return (rule, value, callback) => {
      if (value === "" || value === null || value === undefined) {
         callback(new Error(message));
         return;
      }
      if (Number(value) < 0) {
         callback(new Error("金额不能小于0"));
         return;
      }
      callback();
   };
};

const rules = {
   productCode: [
      { required: true, message: "请填写产品编码", trigger: "blur" },
   ],
   productName: [
      { required: true, message: "请填写产品名称", trigger: "blur" },
   ],
   annualFee: [
      { required: true, validator: validateNonNegative("请填写年度费用"), trigger: "blur" },
   ],
   unionSubsidy: [
      { required: true, validator: validateNonNegative("请填写工会补助金额"), trigger: "blur" },
   ],
   memberFee: [
      { required: true, validator: validateNonNegative("请填写会员支付金额"), trigger: "blur" },
   ],
};

const goBack = () => {
   router.push("/safeguardProduct");
};

const loadDetail = () => {
   const id = route.query.id || sessionStorage.getItem("mutualInsuranceProductId");
   if (!id) {
      ElMessage({
         message: "缺少保障产品ID",
         type: "error",
         center: true,
      });
      goBack();
      return;
   }

   productId.value = id;
   sessionStorage.setItem("mutualInsuranceProductId", id);
   resetFormData();
   pageLoading.value = true;
   queryProductInfo(qs.stringify({ id })).then((res) => {
      if (res.data.code === 0) {
         const data = res.data.data || {};
         form.productCode = data.productCode || "";
         form.productName = data.productName || "";
         form.annualFee = data.annualFee === 0 || data.annualFee ? data.annualFee : "";
         form.unionSubsidy = data.unionSubsidy === 0 || data.unionSubsidy ? data.unionSubsidy : "";
         form.memberFee = data.memberFee === 0 || data.memberFee ? data.memberFee : "";
         form.status = data.status === 0 || data.status === 1 ? data.status : "";
         form.sort = data.sort === 0 || data.sort ? data.sort : "";
      } else {
         ElMessage({
            message: res.data.msg || "查询保障产品详情失败",
            type: "error",
            center: true,
         });
      }
   }).catch(() => {
      ElMessage({
         message: "查询保障产品详情失败",
         type: "error",
         center: true,
      });
   }).finally(() => {
      pageLoading.value = false;
   });
};

const onSubmit = () => {
   ruleFormRef.value.validate((valid) => {
      if (!valid) {
         return;
      }

      loading.value = true;
      const data = {
         id: Number(productId.value),
         productCode: form.productCode,
         productName: form.productName,
         annualFee: Number(form.annualFee),
         unionSubsidy: Number(form.unionSubsidy),
         memberFee: Number(form.memberFee),
      };

      if (form.status !== "" && form.status !== undefined && form.status !== null) {
         data.status = Number(form.status);
      }
      if (form.sort !== "" && form.sort !== undefined && form.sort !== null) {
         data.sort = Number(form.sort);
      }

      updateProduct(data).then((res) => {
         if (res.data.code === 0) {
            ElMessage({
               message: "提交成功",
               type: "success",
               center: true,
            });
            setTimeout(() => {
               goBack();
            }, 500);
         } else {
            ElMessage({
               message: res.data.msg || "提交失败",
               type: "error",
               center: true,
            });
         }
      }).catch(() => {
         ElMessage({
            message: "编辑保障产品失败",
            type: "error",
            center: true,
         });
      }).finally(() => {
         loading.value = false;
      });
   });
};

onMounted(() => {
   loadDetail();
});

onActivated(() => {
   loadDetail();
});
</script>

<style lang="scss" scoped>
::v-deep .chart-card::-webkit-scrollbar {
   display: none;
}

::v-deep .chart-card {
   height: calc(100vh - 145px);
   overflow: auto;
}

::v-deep .el-button {
   width: 100px;
   height: 40px;
   font-size: 16px;
}

::v-deep .el-form-item__content {
   align-items: flex-end;
}

::v-deep .el-form-item {
   align-items: center;
}

::v-deep .aaaa {
   width: 25%;
}

::v-deep .el-card__body {
   padding: 0;
}

::v-deep .el-main {
   overflow: auto !important;
}

::v-deep .el-card.is-always-shadow {
   width: 95%;
   margin: auto;
   margin-top: 10px;
   padding-left: 20px;
   padding-right: 20px;
   padding-bottom: 20px;
}

::v-deep .tabulation {
   margin-top: 10px;
   display: flex;
   justify-content: center;
   align-items: center;
   margin-bottom: 10px;
   overflow: auto !important;
}
</style>

<style scoped>
::v-deep .el-input {
   height: 44px !important;
}

::v-deep .el-form-item__label {
   width: 125px !important;
   font-weight: bold;
}

::v-deep .submit {
   margin-left: 125px;
}

::v-deep .el-select {
   width: 100%;
}
</style>
